import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { all_routes } from "../../router/all_routes";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import dragula, { Drake } from "dragula";
import "dragula/dist/dragula.css";
import api from "../../../services/api";
import Loader from "../../../core/common/loader";
import CommonSelect from "../../../core/common/commonSelect";
import { showBasicAlert } from "../../../core/common/useAlert";
import PredefinedDateRangesOneMonth from "../../../core/common/datePickerOneMonth";
import { Menu, MenuItem, IconButton } from "@mui/material";
import { MoreVert as MoreVertIcon } from "@mui/icons-material";
import EditLead from "./editLead";
import moment from "moment";
import { useLocation, useNavigate } from "react-router-dom";
import "./deal-grid.css";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Avatar,
  Typography,
  Grid,
  Box,
  Divider,
} from "@mui/material";

// Define FormData type
interface FormField {
  id: string;
  label: string;
  type: "text" | "select";
  options?: string[];
}

interface FormData {
  structure: FormField[];
  responses?: { [key: string]: string };
}
const DealsGrid = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const user = useSelector((state: any) => state.user.user);
  const previousSelectedCompanyDetails = location.state?.companyDetails || null;
  const previousSelectedformDetails = location.state?.formDetails || null;
  const [users, setUsers] = useState<any[]>([]);

  const signature = localStorage.getItem("signature");
  const [isLoading, setIsLoading] = useState(false);
  const [dateFilterActive, setdateFilterActive] = useState(false);

  const [getAllCompanyLists, setgetAllCompanyList] = useState<any[]>([]);
  const [data, setData] = useState<any[]>([]);
  const [pipelines, setPipelines] = useState<any[]>([]); // Pipeline Stages (e.g., Not Contacted, Contacted)
  const [pipelinesColor, setPipelinesColor] = useState<any[]>([]); // Pipeline Stages (e.g., Not Contacted, Contacted)

  const [newTransferLead, setNewTransferLead] = useState<any[]>([]);
  const [isTransferOpen, setIsTransferOpen] = useState(false);
  const [ackLoading, setAckLoading] = useState(false);

  const [leads, setLeads] = useState<any[]>([]); // Lead Data
  const [HeaderGrid, setHeaderGrid] = useState<any>({}); // References for Dragula
  const [searchQuery, setSearchQuery] = useState(""); // Search Query State
  const [filteredLeads, setFilteredLeads] = useState<any[]>([]); // Filtered Lead Data
  const [sortBy, setSortBy] = useState<string>("Recently Added");
  const [selectedStartDate, setSelectedStartDate] = useState<moment.Moment>(
    moment().subtract(29, "days")
  );
  const [selectedEndDate, setSelectedEndDate] = useState<moment.Moment>(
    moment()
  );
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [isEditOpen, setIsEditOpen] = useState(false);

  const [selectedLead, setSelectedLead] = useState<FormData | null>(null);

  const drakeRef = useRef<Drake | null>(null);
  const routes = all_routes;

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        await updateUI();
      } catch (err) {
        console.error("Error fetching dashboard data:", err);
      }
    };

    fetchDashboardData();
  }, []);

  const updateUI = async () => {
    setIsLoading(true);
    const [getAllCompanyList] = await Promise.all([
      api.post("userService/getAllCompanyList", { signature }),
    ]);

    var finalCompanyList: any = [];
    for (let i = 0; i < getAllCompanyList.data.data.data.length; i++) {
      const [getLeadForms] = await Promise.all([
        api.post("leadService/getLeadFormsByCompany", {
          signature,
          company_id: getAllCompanyList.data.data.data[i].id,
          company_type: getAllCompanyList.data.data.data[i].type,
        }),
      ]);

      let dealForms = [];
      for (let j = 0; j < getLeadForms?.data?.data?.data?.length; j++) {
        const item = getLeadForms.data.data.data[j];
        if (
          item.deal_pipeline_id != null &&
          item.deal_pipeline_id != "" &&
          item.deal_pipeline_id != undefined
        ) {
          dealForms.push(item);
        }
      }

      if (dealForms.length > 0) {
        finalCompanyList.push(getAllCompanyList.data.data.data[i]);
      }
    }
    setgetAllCompanyList(finalCompanyList);
  };

  useEffect(() => {
    if (getAllCompanyLists.length) {
      if (previousSelectedCompanyDetails) {
        handleCompanyChange({
          value: previousSelectedCompanyDetails?.companyId,
          label:
            previousSelectedCompanyDetails?.companyName +
            "-" +
            previousSelectedCompanyDetails?.companyType,
        });
      } else {
        handleCompanyChange({
          value: getAllCompanyLists?.[0]?.id,
          label:
            getAllCompanyLists?.[0]?.name + "-" + getAllCompanyLists?.[0]?.type,
        });
      }
    }
  }, [getAllCompanyLists]);

  const handleDateChange = async (start: moment.Moment, end: moment.Moment) => {
    setSelectedStartDate(start);
    setSelectedEndDate(end);
    setdateFilterActive(true);
  };

  useEffect(() => {
    if (dateFilterActive == true) {
      handleCompanyChange({
        value: formDataCompanyChoose.companyId,
        label:
          formDataCompanyChoose.companyName +
          "-" +
          formDataCompanyChoose.companyType,
      });
      setdateFilterActive(false);
    }
  }, [dateFilterActive]);

  useEffect(() => {
    if (
      searchQuery === "" &&
      sortBy.length === 0 &&
      !selectedStartDate &&
      !selectedEndDate
    ) {
      setFilteredLeads(leads); // Reset to all leads when no filters are applied
      return;
    }

    let newFilteredLeads: any = {};

    // Step 1: Apply Search Filter
    Object.keys(leads).forEach((pipeline: any) => {
      newFilteredLeads[pipeline] = leads[pipeline].filter((lead: any) =>
        Object.values(lead).some(
          (value) =>
            typeof value === "string" &&
            value.toLowerCase().includes(searchQuery.toLowerCase())
        )
      );
    });

    // Step 3: Apply Sorting Logic
    if (sortBy === "Recently Added") {
      Object.keys(newFilteredLeads).forEach((pipeline) => {
        newFilteredLeads[pipeline].sort(
          (a: any, b: any) =>
            new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
        );
      });
    } else if (sortBy === "Ascending(Company)") {
      Object.keys(newFilteredLeads).forEach((pipeline) => {
        newFilteredLeads[pipeline].sort((a: any, b: any) =>
          a.CompanyName.localeCompare(b.CompanyName)
        );
      });
    } else if (sortBy === "Descending(Company)") {
      Object.keys(newFilteredLeads).forEach((pipeline) => {
        newFilteredLeads[pipeline].sort((a: any, b: any) =>
          b.CompanyName.localeCompare(a.CompanyName)
        );
      });
    } else if (sortBy === "Ascending(Name)") {
      Object.keys(newFilteredLeads).forEach((pipeline) => {
        newFilteredLeads[pipeline].sort((a: any, b: any) =>
          a.LeadName.localeCompare(b.LeadName)
        );
      });
    } else if (sortBy === "Descending(Name)") {
      Object.keys(newFilteredLeads).forEach((pipeline) => {
        newFilteredLeads[pipeline].sort((a: any, b: any) =>
          b.LeadName.localeCompare(a.LeadName)
        );
      });
    } else if (sortBy === "Last Month") {
      Object.keys(newFilteredLeads).forEach((pipeline) => {
        newFilteredLeads[pipeline] = newFilteredLeads[pipeline].filter(
          (lead: any) => {
            const leadDate = new Date(lead.createdAt);
            const lastMonth = new Date();
            lastMonth.setMonth(lastMonth.getMonth() - 1);
            return leadDate >= lastMonth;
          }
        );
      });
    } else if (sortBy === "Last 7 Days") {
      Object.keys(newFilteredLeads).forEach((pipeline) => {
        newFilteredLeads[pipeline] = newFilteredLeads[pipeline].filter(
          (lead: any) => {
            const leadDate = new Date(lead.createdAt);
            const sevenDaysAgo = new Date();
            sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
            return leadDate >= sevenDaysAgo;
          }
        );
      });
    }

    setFilteredLeads(newFilteredLeads);
  }, [searchQuery, sortBy]);

  const refreshPage = async (type: any) => {
    if (type.toLowerCase() == "cancel") {
      return;
    } else if (type == "updateUI") {
      handleCompanyChange(
        {
          value: formDataCompanyChoose?.companyId,
          label:
            formDataCompanyChoose?.companyName +
            "-" +
            formDataCompanyChoose?.companyType,
        },
        "updateUI"
      );
    }
  };

  // Initialize Dragula only when data is available
  useEffect(() => {
    if (isLoading || pipelines.length === 0) return;

    const containerRefs = pipelines.reduce((acc: any, pipeline: string) => {
      acc[pipeline] = document.getElementById(`pipeline-${pipeline}`);
      return acc;
    }, {});

    if (drakeRef.current) {
      drakeRef.current.destroy();
    }

    drakeRef.current = dragula(Object.values(containerRefs)).on(
      "drop",
      async (el, target) => {
        const lead_id = el.getAttribute("data-id");
        const pipeline = target.getAttribute("data-pipeline-id");

        // Update lead status in the backend
        try {
          await api.post("leadService/updateDealResponsePipeline", {
            signature,
            pipeline,
            lead_id,
          });
          refreshPage("updateUI");
        } catch (err) {
          showBasicAlert("Something went wrong");
          console.error("Error updating lead pipeline:", err);
        }
      }
    );

    return () => {
      if (drakeRef.current) {
        drakeRef.current.destroy();
        drakeRef.current = null;
      }
    };
  }, [isLoading, getAllCompanyLists, pipelines]);

  var initialFormDataChooseCompany = {
    signature: signature,
    companyName: "Select Company",
    companyId: "",
    companyType: "Deals",
  };
  const [formDataCompanyChoose, setformDataCompanyChoose] = useState(
    initialFormDataChooseCompany
  );
  const companyChoose = [
    ...getAllCompanyLists?.map((company: any) => ({
      value: company.id,
      label: company.name + " - " + company.type,
    })),
  ];

  const handleCompanyChange = async (selectedOption: any, type: any = null) => {
    if (!selectedOption || selectedOption.value == "") return;
    setIsLoading(true);
    const newFormData = {
      companyId: selectedOption.value,
      companyName: selectedOption.label.split("-")[0].trim(),
      companyType: selectedOption.label.split("-")[1].trim(),
    };

    setformDataCompanyChoose((prev: any) => ({
      ...prev,
      ...newFormData,
    }));

    if (dateFilterActive == false) {
      if (type == "updateUI") {
        handleLeadFormChange({
          value:
            formDataFormChoose.pipeline_id + "-" + formDataFormChoose.form_id,
          label: formDataFormChoose.form_name,
        });
      } else {
        const [getLeadForms] = await Promise.all([
          api.post("leadService/getLeadFormsByCompany", {
            signature,
            company_id: newFormData.companyId,
            company_type: newFormData.companyType,
          }),
        ]);
        const allForms = getLeadForms?.data?.data?.data || [];

        // Filter out where deal_pipeline_id is null, undefined, or ""
        const filteredForms = allForms.filter(
          (leadForm: any) =>
            leadForm.deal_pipeline_id != null &&
            leadForm.deal_pipeline_id !== ""
        );

        // Set filtered data
        setData(filteredForms);
      }
    } else {
      handleLeadFormChange({
        value:
          formDataFormChoose.pipeline_id + "-" + formDataFormChoose.form_id,
        label: formDataFormChoose.form_name,
      });
    }
  };

  const leadFormChoose = (data || [])
    .filter(
      (leadForm: any) =>
        leadForm.deal_pipeline_id !== null && leadForm.deal_pipeline_id !== ""
    )
    .map((leadForm: any) => ({
      value: `${leadForm.deal_pipeline_id}-${leadForm.key}`,
      label: leadForm.LeadFormName,
    }));

  const userChoose = [
    { value: "0", label: "All Employees" },
    ...users?.map((usr: any) => ({
      value: usr.key,
      label: usr.Name,
    })),
  ];

  var initialFormDataChooseForm = {
    signature: signature,
    pipeline_id: "",
    form_name: "",
    form_id: "",
    user_id: "0",
    user_name: "All Employees",
  };
  const [formDataFormChoose, setformDataFormChoose] = useState(
    initialFormDataChooseForm
  );

  useEffect(() => {
    if (data.length && formDataCompanyChoose.companyId != "") {
      if (previousSelectedformDetails) {
        handleLeadFormChange({
          value:
            previousSelectedformDetails?.pipeline_id +
            "-" +
            previousSelectedformDetails?.form_id,
          label: previousSelectedformDetails?.form_name,
        });

        handleUserChange({
          value: previousSelectedformDetails?.user_id,
          label: previousSelectedformDetails?.user_name,
        });
      } else {
        handleLeadFormChange({
          value: data?.[0]?.deal_pipeline_id + "-" + data?.[0]?.key,
          label: data?.[0]?.LeadFormName,
        });
      }
    } else {
      setIsLoading(false);
      handleLeadFormChange({
        value: "",
        label: "No Lead Form",
      });
    }
  }, [data]);

  const handleLeadFormChange = async (selectedOption: any) => {
    try {
      //To clear previousSelectComapnyDetail from state
      if (
        !selectedOption ||
        selectedOption.value == "" ||
        selectedOption.label == ""
      ) {
        const newFormData = {
          pipeline_id: selectedOption.value?.split("-")[0],
          form_name: selectedOption.label,
          form_id: selectedOption.value?.split("-")[1],
        };
        setformDataFormChoose((prev: any) => ({
          ...prev,
          ...newFormData,
        }));
        return;
      }
      setIsLoading(true);
      const newFormData = {
        pipeline_id: parseInt(selectedOption.value?.split("-")[0]),
        form_name: selectedOption.label,
        form_id: parseInt(selectedOption.value?.split("-")[1]),
      };

      setformDataFormChoose((prev: any) => ({
        ...prev,
        ...newFormData,
      }));

      const [pipelineList, fetchedLeads, getLeadSettings, getNewTransferLeads] =
        await Promise.all([
          api.post("leadService/getAllPipelinesById", {
            signature,
            id: newFormData.pipeline_id,
          }),
          api.post("leadService/getAllDealsResponse", {
            signature,
            company_id: formDataCompanyChoose.companyId,
            company_type: formDataCompanyChoose.companyType,
            start_date: moment(selectedStartDate.toDate()).format("YYYY-MM-DD"),
            end_date: moment(selectedEndDate.toDate()).format("YYYY-MM-DD"),
            form_id: newFormData.form_id,
            ...(formDataFormChoose.user_id !== "0" && {
              user_id: formDataFormChoose.user_id,
            }),
          }),
          api.post("leadService/getAllLeadSettings", {
            signature,
            company_id: parseInt(formDataCompanyChoose.companyId),
            company_type: formDataCompanyChoose.companyType,
          }),
          api.post("leadService/getTransferLeadsByUser", {
            signature,
            company_id: formDataCompanyChoose.companyId,
            company_type: formDataCompanyChoose.companyType,
            form_id: newFormData.form_id,
          }),
        ]);

      const [responseUser] = await Promise.all([
        api.post("userService/getLeadEmployeesListData", {
          signature,
          department:
            getLeadSettings?.data?.data?.data[0]?.settings
              ?.lead_assigned_to_department || -1,
          company_id: parseInt(formDataCompanyChoose.companyId),
          company_type: formDataCompanyChoose.companyType,
        }),
      ]);
      setUsers(responseUser.data?.data?.data?.allUsers || []);

      navigate(
        {
          pathname: location.pathname,
          search: location.search,
        },
        {
          replace: true,
          state: {
            ...location.state,
            companyDetails: undefined,
            formDetails: undefined,
          },
        }
      );

      const filteredDataPipeline = pipelineList.data.data.data;
      setPipelines(filteredDataPipeline[0]?.Stages || []);
      setPipelinesColor(filteredDataPipeline[0]?.Color || []);
      setNewTransferLead(getNewTransferLeads.data.data.data);

      const groupedLeads = await filteredDataPipeline[0]?.Stages.reduce(
        (acc: any, pipeline_char: any) => {
          acc[pipeline_char] = fetchedLeads.data.data.data.filter(
            (lead: any) =>
              lead.pipeline_char.toLowerCase() === pipeline_char.toLowerCase()
          );
          return acc;
        },
        {}
      );
      setLeads(groupedLeads);
      setFilteredLeads(groupedLeads);

      const leadStats = Object.entries(
        fetchedLeads.data.data.data[0]?.Items || {}
      ).map(([key, value]: any) => {
        let icon = "";
        let color = "";
        let progressColor = "";

        // Assign fixed values based on key
        switch (key) {
          case "Total Deals":
            icon = "ti-stack-middle";
            color = "bg-primary";
            progressColor = "bg-primary";
            break;
          case "Today’s Deals":
            icon = "ti-calendar";
            color = "bg-success";
            progressColor = "bg-success";
            break;
          case "Yesterday’s Deals":
            icon = "ti-calendar-event";
            color = "bg-warning";
            progressColor = "bg-warning";
            break;
          case "This Month’s Deals":
            icon = "ti-calendar-month";
            color = "bg-info";
            progressColor = "bg-info";
            break;
          default:
            icon = "ti-briefcase"; // Fallback icon
            color = "bg-secondary";
            progressColor = "bg-secondary";
        }

        return {
          title: key,
          value: value,
          icon,
          color,
          progressColor,
        };
      });

      setHeaderGrid(leadStats);
      setIsLoading(false);
    } catch (e) {
      console.log(e);
    }
  };

  const handleUserChange = async (selectedOption: any) => {
    if (!selectedOption || selectedOption.value == "") return;
    const newFormData = {
      user_id: selectedOption.value,
      user_name: selectedOption.label,
    };

    setformDataFormChoose((prev: any) => ({
      ...prev,
      ...newFormData,
    }));
  };

  useEffect(() => {
    handleLeadFormChange({
      value: formDataFormChoose.pipeline_id + "-" + formDataFormChoose.form_id,
      label: formDataFormChoose.form_name,
    });
  }, [formDataFormChoose.user_id]);

  const getRandomColor = () => {
    const letters = "0123456789ABCDEF";
    let color = "#";
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  };

  const handleMenuOpen = (event: any, lead: any) => {
    setAnchorEl(event.currentTarget);
    setSelectedLead(lead);
  };

  // Function to handle menu close
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  // Function to open EditLead modal
  const handleEditLead = () => {
    setIsEditOpen(true);
    handleMenuClose();
  };

  // Function to close EditLead modal
  const handleCloseEdit = () => {
    refreshPage("cancel");
    setIsEditOpen(false);
  };

  const handleAcknowledgeTransfer = async () => {
    try {
      setAckLoading(true);
      await Promise.all([
        api.post("leadService/markLeadTransferStatus", {
          signature,
          company_id: formDataCompanyChoose.companyId,
          company_type: formDataCompanyChoose.companyType,
          form_id: formDataFormChoose.form_id,
        }),
      ]);

      setIsTransferOpen(false);
    } catch (e) {
      console.error(e);
      showBasicAlert("Something went wrong while acknowledging transfers");
    } finally {
      setAckLoading(false);
    }
  };

  return (
    <>
      {/* Page Wrapper */}
      {isLoading && <Loader />}

      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">👤 Deals</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">CRM</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Deals Grid
                  </li>
                </ol>
              </nav>
            </div>

            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="dropdown me-2 mb-2">
                <CommonSelect
                  className="select"
                  options={leadFormChoose}
                  defaultValue={{
                    value: `${formDataFormChoose.pipeline_id}-${formDataFormChoose.form_id}`,
                    label: formDataFormChoose.form_name,
                  }}
                  onChange={handleLeadFormChange}
                />
              </div>
              <div className="dropdown me-2 mb-2">
                <CommonSelect
                  className="select"
                  options={companyChoose}
                  defaultValue={{
                    value: formDataCompanyChoose.companyId,
                    label:
                      formDataCompanyChoose.companyName +
                      "-" +
                      formDataCompanyChoose.companyType,
                  }}
                  onChange={handleCompanyChange}
                />
              </div>
              <div className="me-2 mb-2">
                <div className="d-flex align-items-center border bg-white rounded p-1 me-2 icon-list">
                  <Link
                    to={`${routes.dealsList}${location?.search}`}
                    state={{
                      companyDetails: formDataCompanyChoose,
                      formDetails: formDataFormChoose,
                    }}
                    className="btn btn-icon btn-sm me-1">
                    <i className="ti ti-list-tree" />
                  </Link>
                  <Link
                    to={`${routes.dealsGrid}?${location?.search}`}
                    className="btn btn-icon btn-sm active bg-primary text-white">
                    <i className="ti ti-layout-grid" />
                  </Link>
                </div>
              </div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="d-flex ms-md-auto my-xl-auto right-content align-items-center flex-wrap">
              <div className="d-flex align-items-center me-2 mb-2">
                <input
                  type="text"
                  className="form-control me-2"
                  placeholder="Search"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </div>

              {(user?.userDetails.role_char.toLowerCase() === "admin" ||
                user?.userDetails.role_char.toLowerCase() ===
                "employeeadmin") && (
                  <div className="dropdown me-2">
                    <CommonSelect
                      className="select"
                      options={userChoose}
                      defaultValue={{
                        value: formDataFormChoose.user_id,
                        label: formDataFormChoose.user_name,
                      }}
                      onChange={handleUserChange}
                    />
                  </div>
                )}
              <div className="dropdown me-3">
                <Link
                  to="#"
                  onClick={(e: any) => e.preventDefault()}
                  className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                  data-bs-toggle="dropdown">
                  Sort By: {sortBy}
                </Link>
                <ul className="dropdown-menu dropdown-menu-end p-3">
                  <li>
                    <Link
                      to="#"
                      className="dropdown-item rounded-1"
                      onClick={(e: any) => {
                        e.preventDefault();
                        setSortBy("Recently Added");
                      }}>
                      Recently Added
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="#"
                      className="dropdown-item rounded-1"
                      onClick={(e: any) => {
                        e.preventDefault();
                        setSortBy("Ascending(Name)");
                      }}>
                      Ascending(Name)
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="#"
                      className="dropdown-item rounded-1"
                      onClick={(e: any) => {
                        e.preventDefault();
                        setSortBy("Descending(Name)");
                      }}>
                      Descending(Name)
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="#"
                      className="dropdown-item rounded-1"
                      onClick={(e: any) => {
                        e.preventDefault();
                        setSortBy("Last Month");
                      }}>
                      Last Month
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="#"
                      className="dropdown-item rounded-1"
                      onClick={(e: any) => {
                        e.preventDefault();
                        setSortBy("Last 7 Days");
                      }}>
                      Last 7 Days
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="me-2 mb-2">
                <div className="input-icon-end position-relative">
                  <PredefinedDateRangesOneMonth
                    startDate={selectedStartDate}
                    endDate={selectedEndDate}
                    onDateChange={handleDateChange}
                  />
                  <span className="input-icon-addon">
                    <i className="ti ti-chevron-down" />
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* /Breadcrumb */}
          {isLoading ? (
            <div>
              <p>No Lead Found</p>
            </div>
          ) : (
            <>
              {pipelines.length > 0 && data.length > 0 && (
                <div>
                  <div className="row">
                    {HeaderGrid.map((stat: any, index: any) => (
                      <div className="col-xl-3 col-md-6 mb-1" key={index}>
                        <div
                          className="card position-relative border-0 shadow-sm h-60"
                          style={{
                            borderRadius: "12px",
                            overflow: "hidden",
                            transition: "all 0.3s",
                          }}>
                          <div className="card-body position-relative z-1 bg-white">
                            {/* Icon + Title + Value */}
                            <div className="d-flex align-items-center mb-3">
                              <div
                                className={`avatar avatar-md rounded-circle d-flex align-items-center justify-content-center ${stat.color}`}
                                style={{
                                  width: "40px",
                                  height: "40px",
                                  background: stat.gradient || "#6366f1",
                                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                                }}>
                                <i
                                  className={`ti ${stat.icon} text-white fs-20`}
                                />
                              </div>
                              <div className="ms-3">
                                <p className="fw-semibold text-muted mb-1 text-truncate">
                                  {stat.title}
                                </p>
                                <h5 className="mb-0 fw-bold text-dark">
                                  {stat.value}
                                </h5>
                              </div>
                            </div>

                            {/* Background Image Overlay */}
                            <span
                              className="position-absolute top-0 end-0 opacity-10"
                              style={{ zIndex: 0 }}>
                              <ImageWithBasePath
                                src="assets/img/bg/card-bg-04.png"
                                alt="bg"
                              />
                            </span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {data.length === 0 && (
                <div
                  className="d-flex justify-content-center align-items-center w-100"
                  style={{ minHeight: "300px" }}>
                  <div className="text-center">
                    <div style={{ fontSize: "40px", color: "#ccc" }}>📭</div>
                    <p className="mt-2 text-muted fs-50">No Deals</p>
                  </div>
                </div>
              )}

              {pipelines.length > 0 && data.length > 0 && filteredLeads && (
                <div>
                  <div className="d-flex overflow-x-auto align-items-start mb-2">
                    {pipelines.map((pipeline, index) => (
                      <div
                        key={pipeline}
                        className="kanban-list-items bg-white">
                        <div
                          className="card mb-1 border-0 shadow-sm"
                          style={{ borderRadius: "12px" }}>
                          <div
                            className="card-body py-3 px-4"
                            style={{
                              backgroundColor:
                                pipelinesColor?.[index] || getRandomColor(), // still uses your function
                            }}>
                            <h5 className="fw-semibold mb-1 d-flex align-items-center text-dark text-white">
                              <span
                                className="d-inline-flex align-items-center justify-content-center rounded-circle me-2"
                                style={{
                                  width: "12px",
                                  height: "12px",
                                  backgroundColor: "#FFFFFF", // still uses your function
                                }}>
                                {/* empty span used as dot */}
                              </span>
                              {pipeline}
                            </h5>

                            <span className="fw-medium text-white small">
                              {filteredLeads[pipeline]?.length || 0} Leads
                            </span>
                          </div>
                        </div>

                        {/* Kanban Drag Container */}
                        <div
                          className="kanban-drag-wrap pt-4"
                          id={`pipeline-${pipeline}`}
                          data-pipeline-id={pipeline}>
                          {filteredLeads[pipeline]?.map((lead: any) => (
                            <div
                              key={lead.id}
                              className="card kanban-card shadow-sm border-0"
                              data-id={lead.key}
                              style={{
                                borderLeft: "4px solid #4caf50", // green accent
                                backgroundColor: "#f9f9fc",
                                transition: "0.3s",
                              }}>
                              <div className="card-body p-3 pb-2">
                                {/* Top Row: Avatar + Name + Menu */}
                                <div className="d-flex align-items-center mb-2">
                                  <Link
                                    to={`${routes.leadsDetails}${location?.search}`}
                                    state={{
                                      lead,
                                      data,
                                      pipelines,
                                      type: "deal_grid",
                                      selectedCompanyDetails:
                                        formDataCompanyChoose,
                                      selectedLeadFormDetails:
                                        formDataFormChoose,
                                    }}
                                    className="avatar avatar-sm bg-primary text-white fw-semibold rounded-circle d-flex align-items-center justify-content-center me-2 text-uppercase shadow-sm"
                                    style={{
                                      width: 38,
                                      height: 38,
                                      fontSize: "13px",
                                    }}>
                                    {lead.response["Full Name"]
                                      ?.split(" ")
                                      .map((word: any) => word[0])
                                      .join("")
                                      .toUpperCase()}
                                  </Link>

                                  <div className="flex-grow-1">
                                    <h6
                                      className="mb-0 fw-semibold text-truncate"
                                      style={{ fontSize: "14px" }}>
                                      <Link
                                        to={`${routes.leadsDetails}${location?.search}`}
                                        state={{
                                          lead,
                                          data,
                                          pipelines,
                                          type: "deal_grid",
                                          selectedCompanyDetails:
                                            formDataCompanyChoose,
                                          selectedLeadFormDetails:
                                            formDataFormChoose,
                                        }}
                                        className="text-dark text-decoration-none">
                                        {lead.response["Full Name"]}
                                      </Link>
                                    </h6>
                                    <small className="text-muted">
                                      {lead.company_name}
                                    </small>
                                  </div>

                                  <div className="ms-auto">
                                    <IconButton
                                      size="small"
                                      onClick={(event) =>
                                        handleMenuOpen(event, {
                                          structure: data.find(
                                            (item) =>
                                              parseInt(item.key) ===
                                              parseInt(lead.form_id)
                                          )?.structure,
                                          responses: lead.response,
                                          id: lead.key,
                                        })
                                      }>
                                      <MoreVertIcon fontSize="small" />
                                    </IconButton>
                                    <Menu
                                      anchorEl={anchorEl}
                                      open={Boolean(anchorEl)}
                                      onClose={handleMenuClose}>
                                      <MenuItem onClick={handleEditLead}>
                                        Edit Lead
                                      </MenuItem>
                                    </Menu>
                                  </div>
                                </div>

                                {/* Lead Info */}
                                <div className="mb-2 small text-muted">
                                  <div className="d-flex align-items-center mb-1">
                                    <i className="ti ti-circle text-primary me-2" />{" "}
                                    <span>{lead.lead_id || "N/A"}</span>
                                  </div>
                                  <div className="d-flex align-items-center mb-1">
                                    <i className="ti ti-mail text-info me-2" />{" "}
                                    <span>{lead.email || "N/A"}</span>
                                  </div>
                                  <div className="d-flex align-items-center mb-1">
                                    <i className="ti ti-phone text-success me-2" />{" "}
                                    <span>{lead.mobile_no || "N/A"}</span>
                                  </div>
                                  <div className="d-flex align-items-center">
                                    <i className="ti ti-clock text-warning me-2" />{" "}
                                    <span>
                                      {lead.createdAt.split(",")[1]?.trim() ||
                                        "N/A"}
                                    </span>
                                  </div>
                                </div>

                                {/* Assigned + Footer */}
                                <div className="d-flex align-items-center justify-content-between border-top pt-2 mt-2">
                                  <div className="d-flex align-items-center">
                                    <span className="avatar avatar-xs me-2">
                                      <ImageWithBasePath
                                        src={
                                          lead.Logo !== ""
                                            ? lead.Logo
                                            : "assets/img/company/company-01.svg"
                                        }
                                        alt="image"
                                        className="img-fluid rounded-circle"
                                      />
                                    </span>
                                    <small
                                      className="text-dark text-truncate"
                                      style={{ maxWidth: "100px" }}>
                                      {lead?.assigned_to_name?.trim() || "N/A"}
                                    </small>
                                  </div>

                                  <div className="d-flex align-items-center gap-2">
                                    <Link
                                      to="#"
                                      onClick={(e: any) => {
                                        e.preventDefault();
                                        showBasicAlert("Coming Soon");
                                      }}>
                                      <i className="ti ti-phone-check text-secondary" />
                                    </Link>
                                    <Link
                                      to="#"
                                      onClick={(e: any) => {
                                        e.preventDefault();
                                        showBasicAlert("Coming Soon");
                                      }}>
                                      <i className="ti ti-message-circle-2 text-secondary" />
                                    </Link>
                                    <Link
                                      to="#"
                                      onClick={(e: any) => {
                                        e.preventDefault();
                                        const phone = lead.mobile_no?.replace(
                                          /\D/g,
                                          ""
                                        );
                                        if (phone) {
                                          window.open(
                                            `https://wa.me/${phone}`,
                                            "_blank"
                                          );
                                        } else {
                                          showBasicAlert(
                                            "Phone number not available"
                                          );
                                        }
                                      }}>
                                      <i className="ti ti-brand-whatsapp text-success" />
                                    </Link>
                                    <small className="text-muted">
                                      {moment(
                                        lead.createdAt.split(",")[0]
                                      ).format("MMM D")}
                                    </small>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </>
          )}
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2025 © CMS.</p>
          <p>
            Designed & Developed By{" "}
            <Link
              to="#"
              onClick={(e: any) => e.preventDefault()}
              className="text-primary">
              ZYVO
            </Link>
          </p>
        </div>
      </div>
      {/* /Page Wrapper */}
      {/* Leads Grid */}

      {/* Leads Kanban */}

      {selectedLead && (
        <EditLead
          open={isEditOpen}
          onClose={handleCloseEdit}
          updateUI={() => {
            setIsEditOpen(false);
            refreshPage("updateUI");
          }}
          data={[selectedLead]}
        />
      )}

      {/* Transfer Leads Popup */}
      <Dialog
        open={isTransferOpen}
        // Backdrop click/ESC se band NA ho
        onClose={(_, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") return;
        }}
        disableEscapeKeyDown
        fullWidth
        maxWidth="md">
        <DialogTitle>
          New Lead Transfers
          <Typography variant="body2" color="text.secondary">
            The following leads were transferred to you.
          </Typography>
        </DialogTitle>

        <DialogContent dividers>
          {!newTransferLead || newTransferLead.length === 0 ? (
            <Typography>No transfers found.</Typography>
          ) : (
            <Grid container spacing={2}>
              {newTransferLead.map((item: any) => (
                <Grid item xs={12} key={item.key}>
                  <Box
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      border: "1px solid #eee",
                      bgcolor: "#fafafa",
                    }}>
                    <Grid container spacing={2} alignItems="center">
                      <Grid item xs={12} md={6}>
                        <Typography variant="body2">
                          Lead ID: <b>{item.lead_id || "-"}</b>
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          Stage: {item.Stage || "-"}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          Transfer Date:{" "}
                          {item.TransferDate
                            ? moment(item.TransferDate).format(
                              "DD MMM YYYY, HH:mm"
                            )
                            : "-"}
                        </Typography>
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <Typography
                          variant="body2"
                          fontWeight={600}
                          gutterBottom>
                          Lead
                        </Typography>
                        <Typography variant="body2">
                          Name: {item.Name || "-"}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          Mobile: {item.MobileNo || "-"}
                        </Typography>
                      </Grid>

                      <Grid item xs={12}>
                        <Divider />
                      </Grid>

                      {/* Person */}

                      {/* From → To */}
                      <Grid item xs={12} md={6}>
                        <Typography
                          variant="body2"
                          fontWeight={600}
                          gutterBottom>
                          Transfer
                        </Typography>
                        <Box display="flex" alignItems="center" gap={2}>
                          <Box display="flex" alignItems="center" gap={1}>
                            <Avatar
                              src={item.FromImage || ""}
                              sx={{ width: 30, height: 30 }}
                            />
                            <Typography variant="body2">
                              {item.From || "-"}
                            </Typography>
                          </Box>
                          <Typography variant="body2">→</Typography>
                          <Box display="flex" alignItems="center" gap={1}>
                            <Avatar
                              src={item.ToImage || ""}
                              sx={{ width: 30, height: 30 }}
                            />
                            <Typography variant="body2">
                              {item.To || "-"}
                            </Typography>
                          </Box>
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              ))}
            </Grid>
          )}
        </DialogContent>

        <DialogActions sx={{ p: 2 }}>
          {/* koi Cancel button nahi, sirf OK */}
          <Button
            variant="contained"
            onClick={handleAcknowledgeTransfer}
            disabled={ackLoading}>
            {ackLoading ? "Please wait..." : "Okay"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DealsGrid;
